export const REPORT_PERIODS = [
  { key: "this_quarter_to_date", label: "This quarter to date" },
  { key: "this_quarter", label: "This quarter" },

  { key: "this_fiscal_quarter_to_date", label: "This fiscal quarter to date" },
  { key: "this_fiscal_quarter", label: "This fiscal quarter" },

  { key: "this_year", label: "This year" },
  { key: "this_year_to_date", label: "This year to date" },
  { key: "this_year_to_last_month", label: "This year to last month" },

  { key: "this_fiscal_year", label: "This fiscal year" },
  { key: "this_fiscal_year_to_date", label: "This fiscal year to date" },
  { key: "this_fiscal_year_to_last_month", label: "This fiscal year to last month" },

  { key: "last_year", label: "Last year" },
  { key: "last_fiscal_year", label: "Last fiscal year" },

  // Dates come from the From/To inputs instead of being derived — see
  // getDatesForPeriod, which returns null so callers leave them alone
  { key: "custom", label: "Custom" },
];

export const CUSTOM_PERIOD = "custom";

// YYYY-MM-DD
const formatDate = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

export const getDatesForPeriod = (periodKey) => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();

  const quarter = Math.floor(month / 3);
  const startOfQuarter = new Date(year, quarter * 3, 1);
  const endOfQuarter = new Date(year, quarter * 3 + 3, 0);

  const startOfYear = new Date(year, 0, 1);
  const endOfYear = new Date(year, 11, 31);

  const endOfLastMonth = new Date(year, month, 0);

  const startOfLastYear = new Date(year - 1, 0, 1);
  const endOfLastYear = new Date(year - 1, 11, 31);

  switch (periodKey) {
    case "this_quarter_to_date":
      return { from: formatDate(startOfQuarter), to: formatDate(today) };

    case "this_quarter":
      return { from: formatDate(startOfQuarter), to: formatDate(endOfQuarter) };

    case "this_fiscal_quarter_to_date":
      return { from: formatDate(startOfQuarter), to: formatDate(today) };

    case "this_fiscal_quarter":
      return { from: formatDate(startOfQuarter), to: formatDate(endOfQuarter) };

    case "this_year":
      return { from: formatDate(startOfYear), to: formatDate(endOfYear) };

    case "this_year_to_date":
      return { from: formatDate(startOfYear), to: formatDate(today) };

    case "this_year_to_last_month":
      return { from: formatDate(startOfYear), to: formatDate(endOfLastMonth) };

    case "this_fiscal_year":
      return { from: formatDate(startOfYear), to: formatDate(endOfYear) };

    case "this_fiscal_year_to_date":
      return { from: formatDate(startOfYear), to: formatDate(today) };

    case "this_fiscal_year_to_last_month":
      return { from: formatDate(startOfYear), to: formatDate(endOfLastMonth) };

    case "last_year":
      return { from: formatDate(startOfLastYear), to: formatDate(endOfLastYear) };

    case "last_fiscal_year":
      return { from: formatDate(startOfLastYear), to: formatDate(endOfLastYear) };

    default:
      return null;
  }
};
